export const localBonds = process.env.REACT_APP_BONDS_NETWORK === "local";
export async function loadBondConfig() {
  const url = localBonds ? "/bonds.local.json" : "/bonds.json";
  const response = await fetch(url, { cache: "no-store" });
  if (!response.ok)
    throw new Error("Could not load bond configuration. Please retry.");
  const config = await response.json();
  if (!config.sale) return null;
  if (Number(config.chainId) !== (localBonds ? 31337 : 8453))
    throw new Error("Bond configuration is for the wrong network.");
  const required = ["sale", "receipt", "vault", "locker", "token", "usdc", "nativeBuyer", "pool", "router", "positionManager", "quoter"];
  if (required.some((key) => !/^0x[0-9a-f]{40}$/i.test(config[key] || "") || /^0x0{40}$/i.test(config[key])))
    throw new Error("Bond contract configuration is incomplete. Please try again later.");
  if (!Number.isSafeInteger(config.deploymentBlock) || config.deploymentBlock < 1 || config.nativePoolFee !== 500)
    throw new Error("Bond deployment configuration is invalid. Please try again later.");
  try {
    const rpc = new URL(config.rpc);
    if (!localBonds && rpc.protocol !== "https:") throw new Error();
    if (localBonds && !["http:", "https:"].includes(rpc.protocol)) throw new Error();
    if (!localBonds && config.explorer !== "https://basescan.org") throw new Error();
  } catch {
    throw new Error("Bond network configuration is invalid. Please try again later.");
  }
  return config;
}
